import React, { useContext } from "react";
import toast from "react-hot-toast";
import { Link, useRouteError } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider";

const DisplayError = () => {
  const { logOut } = useContext(AuthContext);

  const error = useRouteError();
  console.log(error);
  const handleLogout = () => {
    logOut()
      .then(() => {
        toast.success("Logged out");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className=" text-center mt-14">
      <p className="text-red-600 text-medium text-2xl">Something went wrong!</p>
      <p className="text-red-400 text-5xl">
        {error.statusText}
        {error.message}
      </p>
      <h3 className="text-3xl">
        Please{" "}
        <Link onClick={handleLogout} to="/register">
          Logout
        </Link>{" "}
        and log back in
      </h3>
    </div>
  );
};

export default DisplayError;
